import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/api";
import { StateResponse } from "../../types/states";


export const getStates = createAsyncThunk<
  StateResponse[],          
  string,           
  { rejectValue: string }    
>(
  "country/getStates",
  async (countryId, { rejectWithValue }) => {
    try {
      const response = await api.get(`locations/get-provinces`, {
        params: {
          countryId,
        },
      });

      if (response.data.Data) {
        return response.data.Data as StateResponse[];
      } else {
        console.error(response.data.message);
        return rejectWithValue(response.data.message);
      }
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.message || error.message);
    }
  }
);



